import { formatPercent } from '../lib/format';
import InfoHint from './InfoHint';

type Props = {
  /** May contain HTML — same as the Flask dashboard's metric labels. */
  label: React.ReactNode;
  value: React.ReactNode;
  /** Raw % change. null/undefined hides the change row. Negative shows down arrow. */
  change?: number | null;
  /** When true, a positive change is "good" (green); when false, a positive change is "bad" (red).
   *  Used for cost metrics where lower is better. */
  positiveIsGood?: boolean;
  periodLabel?: string;
  /** Optional plain-English definition shown via an info icon next to the label. */
  hint?: string;
};

export default function MetricCard({
  label,
  value,
  change,
  positiveIsGood = true,
  periodLabel = 'vs. previous 90 days',
  hint,
}: Props) {
  const hasChange = change !== null && change !== undefined && !Number.isNaN(change);
  const isUp = hasChange && (change as number) >= 0;
  const isPositive = positiveIsGood ? isUp : !isUp;

  return (
    <div className="metric-card">
      <div className="metric-label">
        {label}
        {hint && <InfoHint text={hint} label={typeof label === 'string' ? label : 'Metric'} />}
      </div>
      <div className="metric-value">{value}</div>
      {hasChange && (
        <div className={`metric-change ${isPositive ? 'positive' : 'negative'}`}>
          {isUp ? (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 14l5-5 5 5z" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z" />
            </svg>
          )}
          {formatPercent(change as number)}
          <span className="metric-period">{periodLabel}</span>
        </div>
      )}
    </div>
  );
}
